import React, {  useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Button } from '@app/components';
import { Modal } from 'react-bootstrap';
import { updatePathwayNameAndStatus } from '@app/services/learningPathway';

const UpdatePathwayStatusModal = (props) => {

    const statuses = [{value:'active', label:'Active'}, {value:'inactive', label:'Inactive'}, {value:'draft', label:'Draft'}]
    const [isLoading, setLoading] = useState(false);

    const updatePathwayNameAndStatusAPI = async (payload) => {
        try {
            setLoading(true);
            const resp = await updatePathwayNameAndStatus(props?.payload?.id, payload);
            if(resp.success === true){
                setLoading(false);
                toast.success(resp?.message);
                props.handleClose();
                props.callGetAllLearningPathwayData();
            }else{
                toast.error(resp?.errors[0]?.msg);
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal server error');
        }
    };

    const { handleChange, values, handleSubmit, touched, errors, setFieldValue } = useFormik({
        initialValues: {
            status: props?.payload?.status,
        },
        validationSchema: Yup.object({
            status: Yup.string().required('Please select status'),
        }),
        onSubmit: (values) => {
            updatePathwayNameAndStatusAPI(values);
        },
        enableReinitialize: true,
    });

    return (
    <div>
        <Modal show={props.show} onHide={props.handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Update Pathway Status</Modal.Title>
            </Modal.Header>
            <form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className='row'>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <dt>Pathway Name</dt>
                                <dd>{ props?.payload?.name ?? '---'} </dd>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <dt>Franchise</dt>
                                <dd>{ props?.payload?.franchise_id !== 0 ? props?.payload?.franchise_name : 'FCL Default' }</dd>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <dt>Subject</dt>
                                <dd>{ props?.payload?.subject_name ?? '---'}</dd>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Status <span className="required">*</span></label>
                                <select 
                                    className="form-control"
                                    name="status"
                                    onChange={handleChange} 
                                    value={values.status}
                                >
                                    <option value="">--Please select--</option>
                                    {statuses.length > 0 && statuses.map((obj) => (
                                        <option key={obj.value} value={obj.value}>
                                            {obj.label}
                                        </option>
                                    ))}
                                </select>
                                {(touched.status && errors.status) && (
                                    <div className="text-danger">
                                        {errors.status}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" isLoading={isLoading} className="btn btn-primary mr-2">Update </Button>
                    <Button className='btn btn-default' onClick={props.handleClose}>Close</Button>
                </Modal.Footer>
            </form>
        </Modal>
    </div>
  )
}

export default UpdatePathwayStatusModal;